"use strict";
exports.__esModule = true;
exports.reduceExpandedData = exports.getSquadData = exports.removeAcademicTitlesFromName = exports.getPositionName = exports.getPositionSortNumber = exports.getPositionCrewCategory = exports.getPositionPlayerCategory = void 0;
var tslib_1 = require("tslib");
var CompetitionsApi_1 = tslib_1.__importDefault(require("../../../api/CompetitionsApi"));
var CoreApi_1 = tslib_1.__importDefault(require("../../../api/CoreApi"));
var Competitions_1 = require("../../../library/Competitions");
exports.getPositionPlayerCategory = function (position) {
    switch (position) {
        case 'goalkeeper':
            return 'goalkeepers';
        default:
            return 'players';
    }
};
exports.getPositionCrewCategory = function (position) {
    switch (position) {
        case 'coach':
            return 'coaches';
        default:
            return 'crew';
    }
};
var SORT_ORDER_RULE = [
    'goalkeeper',
    'defender',
    'midfielder',
    'forward',
    'coach',
    'coach_goalkeepers',
    'assist_coach_a',
    'assist_coach_b',
    'doctor',
    'masseur',
    'manager',
    'club_representative',
];
exports.getPositionSortNumber = function (position) {
    var idx = SORT_ORDER_RULE.indexOf(position);
    return idx > -1 ? idx : 999;
};
/**
 * Returns translated player position name.
 * @param position Position id.
 * @params dict Key:value object with translations. If empty or key not found, translation is
 *         obtained from `TeamMemberPositionsTranslationsMap`.
 * @returns
 */
exports.getPositionName = function (position, dict) {
    return ((dict === null || dict === void 0 ? void 0 : dict[position]) || Competitions_1.TeamMemberPositionsTranslationsMap[position] || position);
};
/**
 * Returns users "bio" of specific appSpace.
 * @param appSpace
 * @param user
 * @returns
 */
var getBio = function (appSpace, user) {
    return user.bio
        ? user.bio.find(function (bio) { return bio.org_profile_id === appSpace; })
        : null;
};
exports.removeAcademicTitlesFromName = function (name) {
    return name.replace(/(Mgr\.|Bc\.|Ing\.|Mudr\.|Phd\.|Paeddr\.)/gi, '').trim();
};
/**
 * Returns team members for specified team and year.
 *
 * @param appSpace
 * @param teamId
 * @param year
 */
exports.getSquadData = function (appSpace, teamId, year) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var result, _a, athletes, crew, sportnetIds, users;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                result = {
                    athletes: [],
                    crew: [],
                    users: []
                };
                return [4 /*yield*/, CompetitionsApi_1["default"].publicGetTeamSquad(appSpace, teamId, {
                        date: year + "-01-01"
                    })];
            case 1:
                _a = (_b.sent()), athletes = _a.athletes, crew = _a.crew;
                result.athletes = athletes;
                result.crew = crew;
                sportnetIds = (athletes || []).map(function (athlete) {
                    return athlete.sportnetUser ? athlete.sportnetUser._id : '';
                });
                if (!sportnetIds.length) return [3 /*break*/, 3];
                return [4 /*yield*/, CoreApi_1["default"].organizationPPOUsers(appSpace, {
                        limit: 100,
                        offset: 0,
                        ids: sportnetIds.filter(function (i) { return !!i; })
                    })];
            case 2:
                users = (_b.sent()).users;
                result.users = users;
                _b.label = 3;
            case 3: return [2 /*return*/, result];
        }
    });
}); };
/**
 * Prepares extended data for rendering. For each athlete/crew member selects
 * only needed fields. Players will be grouped by their positions to the
 * resulting object and osrted by their number.
 *
 * @param appSpace Actual appSpace.
 * @param data Extended data from cms.api.
 */
exports.reduceExpandedData = function (appSpace, data, translations) {
    if (!data) {
        return null;
    }
    var athletes = data.athletes, users = data.users, crew = data.crew;
    // create team members objects with only needed fields for rendering
    // members are grouped by theri position
    var playersByPosition = (athletes || []).reduce(function (acc, athlete) {
        var _a, _b;
        var sportnetUser = (users || []).find(function (user) { return user._id === athlete.sportnetUser._id; });
        var bio = sportnetUser ? getBio(appSpace, sportnetUser) : null;
        var fullName = exports.removeAcademicTitlesFromName((_b = (_a = athlete.sportnetUser) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
        var _c = fullName.split(' '), name = _c[0], rest = _c.slice(1);
        var teamMember = {
            name: name,
            surname: rest.join(' '),
            photo: bio === null || bio === void 0 ? void 0 : bio.photo,
            nr: athlete.additionalData.nr,
            position: athlete.additionalData.position,
            positionLabel: exports.getPositionName(athlete.additionalData.position),
            sportnetId: sportnetUser === null || sportnetUser === void 0 ? void 0 : sportnetUser._id
        };
        var _d = teamMember.position, position = _d === void 0 ? 'unknown' : _d;
        var pos = acc.find(function (item) { return item.position === position; });
        if (pos) {
            pos.members.push(teamMember);
        }
        else {
            acc.push({
                position: position,
                sort: exports.getPositionSortNumber(position),
                members: [teamMember]
            });
        }
        return acc;
    }, []);
    // sort by position
    var sortedPlayers = playersByPosition.sort(function (a, b) {
        if (a.sort < b.sort) {
            return -1;
        }
        else if (a.sort > b.sort) {
            return 1;
        }
        else {
            return 0;
        }
    });
    // zoradime hracov podla cisla na kazdej pozicii
    sortedPlayers.forEach(function (position) {
        position.members.sort(function (a, b) {
            return Number(a.nr || '0') < Number(b.nr || '0')
                ? -1
                : Number(a.nr || '0') > Number(b.nr || '0')
                    ? 1
                    : 0;
        });
    });
    // oddelime brankarov od hracov
    var _a = sortedPlayers.reduce(function (acc, item) {
        var _a, _b;
        if (item.position === 'goalkeeper') {
            (_a = acc.goalkeepers).push.apply(_a, item.members);
        }
        else {
            (_b = acc.players).push.apply(_b, item.members);
        }
        return acc;
    }, { goalkeepers: [], players: [] }), goalkeepers = _a.goalkeepers, players = _a.players;
    // create crew members objects with only needed fields for rendering
    // members are grouped by theri position
    var crewMembersByPosition = (crew || []).reduce(function (acc, crewMember) {
        var _a, _b;
        var sportnetUser = (users || []).find(function (user) { return user._id === crewMember.sportnetUser._id; });
        var bio = sportnetUser ? getBio(appSpace, sportnetUser) : null;
        var fullName = exports.removeAcademicTitlesFromName((_b = (_a = crewMember.sportnetUser) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
        var _c = fullName.split(' '), name = _c[0], rest = _c.slice(1);
        var teamMember = {
            name: name,
            surname: rest.join(' '),
            photo: bio === null || bio === void 0 ? void 0 : bio.photo,
            position: crewMember.position,
            positionLabel: exports.getPositionName(crewMember.position, (translations === null || translations === void 0 ? void 0 : translations.crew) || {}),
            sportnetId: sportnetUser === null || sportnetUser === void 0 ? void 0 : sportnetUser._id
        };
        var _d = teamMember.position, position = _d === void 0 ? 'unknown' : _d;
        var pos = acc.find(function (item) { return item.position === position; });
        if (pos) {
            pos.members.push(teamMember);
        }
        else {
            acc.push({
                position: position,
                sort: exports.getPositionSortNumber(position),
                members: [teamMember]
            });
        }
        return acc;
    }, []);
    // sort by position
    var sortedCrewMembers = crewMembersByPosition.sort(function (a, b) {
        if (a.sort < b.sort) {
            return -1;
        }
        else if (a.sort > b.sort) {
            return 1;
        }
        else {
            return 0;
        }
    });
    // oddelime trenerov od ostatnych
    var _b = sortedCrewMembers.reduce(function (acc, item) {
        var _a, _b;
        if (item.position === 'coach') {
            (_a = acc.coaches).push.apply(_a, item.members);
        }
        else {
            (_b = acc.crew).push.apply(_b, item.members);
        }
        return acc;
    }, { coaches: [], crew: [] }), coaches = _b.coaches, otherCrew = _b.crew;
    return {
        goalkeepers: goalkeepers,
        players: players,
        coaches: coaches,
        crew: otherCrew
    };
};
